// Echo guard : vrai pendant l'application d'un changement reçu d'un
// co-éditeur. Le subscriber de structureSync le consulte pour ne pas
// re-diffuser ce qui vient d'arriver (boucle réception → mutation → émission).
// Flag module synchrone (pas dans le store : le poser via set() déclencherait
// lui-même le subscriber).
let applyingRemote = false;

export const isApplyingRemote = () => applyingRemote;

export const withRemoteGuard = (fn) => {
  applyingRemote = true;
  try {
    fn();
  } finally {
    applyingRemote = false;
  }
};
